(function(){
  function addBusinessDays(start, days){
    var d=new Date(start.getFullYear(),start.getMonth(),start.getDate());
    while(days>0){d.setDate(d.getDate()+1);var day=d.getDay();if(day!==0&&day!==6)days--;}
    return d;
  }
  function formatDate(d){return new Intl.DateTimeFormat('en-US',{weekday:'short',month:'short',day:'numeric'}).format(d);}
  function init(root){
    (root||document).querySelectorAll('[data-astro-delivery-box]').forEach(function(box){
      if(box.dataset.astroReady)return; box.dataset.astroReady='1';
      var date=box.querySelector('[data-astro-delivery-date]');
      if(date) date.textContent=formatDate(addBusinessDays(new Date(),3));
      var btn=box.querySelector('.astro-delivery-info');
      if(btn) btn.addEventListener('click',function(e){e.stopPropagation();var open=btn.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');});
    });
  }
  document.addEventListener('click',function(){document.querySelectorAll('.astro-delivery-info.is-open').forEach(function(b){b.classList.remove('is-open');b.setAttribute('aria-expanded','false');});});
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
  init(document);
})();
